(function () {
  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function initWoodfurnistDimensions(section) {
    if (!section || section.dataset.wfDimensionsInitialized === 'true') {
      return;
    }

    section.dataset.wfDimensionsInitialized = 'true';

    var variantJson = section.querySelector(
      '[data-wf-dimension-variants]'
    );

    var cards = section.querySelectorAll('[data-wf-size-card]');
    var currentSizeLabel = section.querySelector(
      '[data-wf-current-size]'
    );

    if (!variantJson || !cards.length) {
      return;
    }

    var variants = [];

    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (error) {
      console.warn('[Woodfurnist Dimensions] Variant JSON error.');
      return;
    }

    function findVariant(variantId) {
      if (!variantId) return null;

      return variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });
    }

    function updateCards(size) {
      if (!size) return;

      cards.forEach(function (card) {
        var cardSize = card.getAttribute('data-size-value');
        var active = normalize(cardSize) === normalize(size);

        card.classList.toggle('is-selected', active);

        var badge = card.querySelector(
          '[data-wf-selected-badge]'
        );

        if (badge) {
          badge.hidden = !active;
        }
      });

      if (currentSizeLabel) {
        currentSizeLabel.textContent = size;
      }

      section.setAttribute('data-current-size', size);
    }

    function getVariantIdFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get('variant');
      } catch (error) {
        return null;
      }
    }

    function getVariantIdFromProductForm() {
      var selectors = [
        'form[action*="/cart/add"] input[name="id"]',
        'product-form input[name="id"]',
        'input[name="id"][type="hidden"]'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var inputs = document.querySelectorAll(selectors[i]);

        for (var j = 0; j < inputs.length; j++) {
          var value = inputs[j].value;

          if (value && findVariant(value)) {
            return value;
          }
        }
      }

      return null;
    }

    function getSelectedSizeControl() {
      var optionName = section.getAttribute(
        'data-size-option-name'
      );

      if (!optionName) return null;

      var optionControls = document.querySelectorAll(
        '[name^="options["]'
      );

      for (var i = 0; i < optionControls.length; i++) {
        var control = optionControls[i];

        if (
          control.name === 'options[' + optionName + ']'
        ) {
          if (
            control.tagName === 'SELECT'
          ) {
            return control.value;
          }

          if (
            (control.type === 'radio' ||
              control.type === 'checkbox') &&
            control.checked
          ) {
            return control.value;
          }
        }
      }

      return null;
    }

    function syncDimensions() {
      /*
       * First preference:
       * current Size option control.
       */
      var selectedControlSize =
        getSelectedSizeControl();

      if (selectedControlSize) {
        updateCards(selectedControlSize);
        return;
      }

      /*
       * Second preference:
       * ?variant= URL.
       */
      var urlVariant = findVariant(
        getVariantIdFromUrl()
      );

      if (urlVariant && urlVariant.size) {
        updateCards(urlVariant.size);
        return;
      }

      /*
       * Third preference:
       * product form hidden variant ID.
       */
      var formVariant = findVariant(
        getVariantIdFromProductForm()
      );

      if (formVariant && formVariant.size) {
        updateCards(formVariant.size);
      }
    }

    /*
     * Initial sync.
     */
    syncDimensions();

    /*
     * Shrine/product selector changes.
     */
    document.addEventListener('change', function () {
      window.setTimeout(syncDimensions, 50);
      window.setTimeout(syncDimensions, 250);
    });

    document.addEventListener('click', function () {
      window.setTimeout(syncDimensions, 80);
      window.setTimeout(syncDimensions, 300);
    });

    /*
     * Common Shopify/theme variant events.
     */
    [
      'variant:change',
      'variantChange',
      'product:variant-change'
    ].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        syncDimensions
      );
    });

    window.addEventListener(
      'popstate',
      syncDimensions
    );

    /*
     * Size help → existing Custom Request.
     */
    var helpButton = section.querySelector(
      '[data-wf-dimensions-request]'
    );

    if (helpButton) {
      helpButton.addEventListener(
        'click',
        function () {
          var customToggle =
            document.querySelector('.wf-custom-toggle');

          if (!customToggle) return;

          customToggle.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          window.setTimeout(function () {
            var customBox =
              customToggle.closest(
                '.wf-custom-request-box'
              );

            if (
              customBox &&
              !customBox.classList.contains('is-open')
            ) {
              customToggle.click();
            }
          }, 450);
        }
      );
    }
  }

  function initAll() {
    document
      .querySelectorAll(
        '[data-wf-component="product-dimensions"]'
      )
      .forEach(function (section) {
        initWoodfurnistDimensions(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var section = event.target.querySelector(
        '[data-wf-component="product-dimensions"]'
      );

      if (section) {
        initWoodfurnistDimensions(section);
      }
    }
  );
})();